import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { capitalize } from 'lodash'

import { Button } from '@/components/buttons/Button'
import { FilterForm } from '@/components/filters/FilterForm'
import { PageHeader } from '@/components/headers/PageHeader'
import { Breadcrumbs } from '@/components/forms/Breadcrumbs/Breadcrumbs'
import { applyFilters } from '@/reducers/realtime/reports/realtimeReports.actions'
import { BaltoAdminOrganizationFilter } from '@/views/RealtimeCoaching/components/filters/BaltoAdminOrganizationFilter'
import { DateRangePicker } from '@/views/RealtimeCoaching/components/filters/DateRangePicker'
import { AgentsDropdown } from '@/views/RealtimeCoaching/components/filters/AgentsDropdown'
import { TagsDropdown } from '@/views/RealtimeCoaching/components/filters/TagsDropdown'
import { AlertTypesDropdown } from '@/views/RealtimeCoaching/components/filters/AlertTypesDropdown'
import { OrgAlertNameDropdown } from '@/views/RealtimeCoaching/components/filters/OrgAlertNameDropdown'
import { GroupByFilter } from '@/views/RealtimeCoaching/components/filters/GroupByFilter'
import { ManagersDropdown } from '@/views/RealtimeCoaching/components/filters/ManagersDropdown'

export const DrillDownReportsFilters = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { resource, tableType } = location.state
  const { currentUser } = useSelector((state) => state)
  const { organization: RTCFiltersOrgId, dateRangeIsValid } = useSelector(
    (state) => state.realtimeCoaching.filters
  )
  const organizationId = RTCFiltersOrgId || currentUser.organizationid
  const isBaltoAdmin = currentUser.organizationid === 1

  const handleFilterSubmit = () => {
    dispatch(applyFilters(resource, organizationId))
  }

  // Populates filter values on load if needed
  useEffect(() => {
    handleFilterSubmit()
  }, [])

  return (
    <>
      <PageHeader
        data-testid="drilldown-header"
        breadcrumbs={
          <Breadcrumbs
            backLinks={[{ label: 'Reports', link: '/realtime_coaching/reports' }]}
            currentLink={`${capitalize(resource)} Reports`}
          />
        }
      />
      <FilterForm
        data-testid="agents-reports-filters"
        onSubmit={handleFilterSubmit}
        actions={
          <Button primary disabled={!dateRangeIsValid} data-testid="filter-button" type="submit">
            Filter
          </Button>
        }
      >
        {isBaltoAdmin && <BaltoAdminOrganizationFilter />}
        <DateRangePicker />

        {tableType === 'supervisorOccurrences' && <ManagersDropdown />}

        {(tableType === 'alert' ||
          tableType === 'supervisorOccurrences' ||
          resource === 'agent') && <AgentsDropdown />}

        {(tableType === 'alert' || tableType === 'supervisorOccurrences' || resource === 'tag') && (
          <TagsDropdown />
        )}
        <AlertTypesDropdown />
        <OrgAlertNameDropdown />
        <GroupByFilter />
      </FilterForm>
    </>
  )
}
